import { ApplicationRef, Injectable, inject, signal, WritableSignal } from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {concat, interval} from 'rxjs';
import {first} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LastUpdate {
  private appRef = inject(ApplicationRef);
  private updates = inject(SwUpdate);
  private readonly _lastUpdate: WritableSignal<boolean> = signal(false);
  readonly current = this._lastUpdate.asReadonly();
  private lastCheck = 0;
  private readonly checkInterval = 5 * 60 * 1000; // 5 minutes

  checkForUpdates = async () => {
    const nowTime = Date.now();
    try {
      if (nowTime - this.lastCheck >= this.checkInterval) {
        this.lastCheck = Date.now();
        const updateFound = await this.updates.checkForUpdate();
        this._lastUpdate.set(updateFound);
      }
    } catch {
      // console.error('Update check failed.');
    }
  }

  constructor() {
    const appIsStable$ = this.appRef.isStable.pipe(first((isStable) => isStable === true));
    const everyHour$ = interval(60 * 60 * 1000);
    const everyHourOnceAppIsStable$ = concat(appIsStable$, everyHour$);
    everyHourOnceAppIsStable$.subscribe(async () => {
      await this.checkForUpdates();
    });
  }
}
